<template>
  <div class="digital_list" v-if="local_list.length > 0">
    <h2 class="category">{{ title }}</h2>
    <b-carousel-list
      v-model="page"
      :data="local_list"
      :items-to-show="itemsToShow"
      icon-size="is-large"
    >
      <template slot="item" slot-scope="product">
        <div class="card">
          <div class="card-image">
            <figure class="image is-16by9">
              <a :href="product.url"><img :src="product.thumbnail_image" /></a>
            </figure>
          </div>
          <div class="card-content">
            <div class="content">
              <p class="title is-6">
                <a :href="product.url">{{ product.title }}</a>
              </p>
              <div v-html="product.short_description"></div>
              <span v-if="product.duration.hours"
                >{{ product.duration.hours }} Hour<span
                  v-if="product.duration.hours > 1"
                  >s</span
                >,
              </span>
              <span v-if="product.duration.minutes"
                >{{ product.duration.minutes }} Minute<span
                  v-if="product.duration.minutes > 1"
                  >s</span
                >,
              </span>
              <span v-if="product.duration.seconds"
                >{{ product.duration.seconds }} Second<span
                  v-if="product.duration.seconds > 1"
                  >s</span
                ></span
              >
              <div>
                <span>{{
                  product.access_types
                    .map((item) => ac_type_to_text[item])
                    .join(", ")
                }}</span>
              </div>
              <!-- <b-field grouped>
                <p class="control" v-if="product.rating !== null">
                  <b-rate :value="product.rating" show-score disabled />
                </p>
              </b-field> -->
            </div>
          </div>
        </div>
      </template>
    </b-carousel-list>
  </div>
</template>

<script>
import Vue from "vue";
import { Carousel } from "buefy";

Vue.use(Carousel);

export default {
  name: "DigitalList",
  props: {
    // This defines the properties passed to the component.
    list: {
      type: Array,
      default: function () {
        return [];
      },
    },
    title: {
      type: String,
      default: "Title is missing!",
    },
    filter_slug: {
      type: String,
      default: "",
    },
    itemsToShow: {
      type: Number,
      default: 3,
    },
    rating: {
      type: Number,
      default: 5,
    },
  },
  data: function () {
    return {
      page: 0,
      ac_type_to_text: {
        FREE: "FREE",
        MEMBER: "MEMBER",
        SUBSCRIBER: "SUBSCRIBER",
        ONE_TIME_FEE: "ONE-TIME FEE",
      },
    };
  },
  computed: {
    // This has to be a computed function, generating this from 'mount:' looses
    // the binding.
    local_list: function () {
      /**
       * Filter the list for the specific filer_slug if provided.
       */
      if (this.filter_slug !== "") {
        return this.list.filter((item) => {
          return item.list_types.includes(this.filter_slug);
        });
      } else {
        return this.list;
      }
    },
  },
  methods: {},
};
</script>
<style lang="scss">
$carousel-arrow-top: 5%;
@import "~bulma";
@import "~buefy/src/scss/buefy";
</style>